import React from 'react';
import { FileText, Check, Trash, Copy, Edit } from 'lucide-react';

interface DocumentActionIconsProps {
    isCreating: boolean;
    isEditing?: boolean; // Optional for backward compatibility
    isSaving: boolean;
    onReset: () => void;
    onSave: () => void;
    onEdit?: () => void; // Optional for backward compatibility
    onDelete?: () => void;
    onCopy?: () => void; // Copy function
    hasDocument?: boolean;
}

const DocumentActionIcons: React.FC<DocumentActionIconsProps> = ({
    isCreating,
    isEditing = false,
    isSaving,
    onReset,
    onSave,
    onEdit,
    onDelete,
    onCopy,
    hasDocument,
}) => {
    return (
        <div className="flex items-center gap-3">
            {/* Edit button - visible when viewing a saved document */}
            {onEdit && (
                <button
                    onClick={onEdit}
                    className={`p-1.5 h-9 rounded-lg transition-all duration-200 flex items-center justify-center ${
                        !hasDocument || isCreating || isEditing || isSaving
                            ? 'text-gray-400 cursor-not-allowed'
                            : 'text-blue-600 hover:text-blue-700 hover:bg-blue-50'
                    }`}
                    disabled={!hasDocument || isCreating || isEditing || isSaving}
                    title="Edit Document"
                >
                    <Edit size={20} />
                </button>
            )}

            {/* Delete button - always visible but disabled when document doesn't exist */}
            {onDelete && (
                <button
                    onClick={onDelete}
                    className={`p-1.5 h-9 rounded-lg transition-all duration-200 flex items-center justify-center ${
                        !hasDocument || isCreating || isSaving
                            ? 'text-gray-400 cursor-not-allowed'
                            : 'text-red-600 hover:text-red-700 hover:bg-red-50'
                    }`}
                    disabled={!hasDocument || isCreating || isSaving}
                    title="Delete Document"
                >
                    <Trash size={20} />
                </button>
            )}
        </div>
    );
};

export default DocumentActionIcons;
